export const LABEL_ITEMS = [
    { name: 'Inbound', label: 'Inbound', value: 'Inbound' },
    { name: 'Outbound', label: 'Outbound', value: 'Outbound' }
]